export const VISUAL_TABLE_WIDGET = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.VisualTableWidgetElement';
